/*eslint-disable */
import {
  mapGetters
} from 'vuex'; 
const $ = window.jQuery = require('jquery'); 
import axios from 'axios'; 
import toast from '../../services/toast';
export default {
  name: 'organizations-list',
  components: {},
  props: [],
  data () {
    return {
      orgList:{},
      nextStep:'',
      orgListResults:[],
      loadmoreData: {},
      userLoading: false,
      submitted:false,
      DeleteId:'',
      checkDataTaskModal:false
    }
  },
  computed: {
  ...mapGetters([
    'OrgListDataGetters'
  ]),
  getOrgListDetailsFun(){
    return this.orgList = this.$store.getters.OrgListDataGetters.data
  },
  SetIntialStatus() {
    if (this.orgList != undefined) {
      this.nextStep = this.orgList.next
      this.orgListResults = this.orgList.results
    }
  }
  },
  mounted () {
    this.getOrgListDetailsFun
    this.SetIntialStatus
  },
  methods: {
    showLoadMoreDataFun(url) {
      this.userLoading = true
      axios.get(url).then((response) => {
          this.loadmoreData = response.data
          this.nextStep = this.loadmoreData.data.next
          this.$set(this.orgList, 'next', this.nextStep)
          if (this.loadmoreData != undefined) {
            for (var i = 0; i < this.loadmoreData.data.results.length; i++) {
              this.orgListResults.push(this.loadmoreData.data.results[i]);
              this.userLoading = false
            }
          }
        });
    },
    getRemoveListAgain() {
      this.$store.dispatch('getOrgListFun').then((res) => {
        this.orgList = this.$store.getters.OrgListDataGetters.data
      }).catch((err) => {
      })
    },
    showRemovedModalFun(id){
      $("body").addClass("task_modal_actv");
      this.checkDataTaskModal = true
      this.DeleteId = id
    },
    removeModalItemConfirmFun(){
      this.$store.dispatch('removeAcOrgFun', {
        id: this.DeleteId,
      })
      .then((res) => {
        if (res.status == '200') {      
          toast.success(res.data.msg); 
          $("body").removeClass("task_modal_actv");
          this.getRemoveListAgain()
          this.checkDataTaskModal = false
          this.DeleteId = ''
        }
      }).catch((err) => {
        toast.error(err.data.user_msg);  
      })
    return;
    },
    closeRemoveItemModalFun(){
      $("body").removeClass("task_modal_actv");
      this.checkDataTaskModal = false
      this.taskDeleteId = ''
    }
  },
  watch:{
    getOrgListDetailsFun(){
      return this.orgList = this.$store.getters.OrgListDataGetters.data
    },
    SetIntialStatus() {
      if (this.orgList != undefined) {
        this.nextStep = this.orgList.next
        this.orgListResults = this.orgList.results
      }
    }
  }
}


